import React, { useCallback, useContext, useEffect, useState } from 'react'
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import Menu from '../../components/Menu';
import axios from 'axios';
import { LoadingContext } from '../../context/LoadingContext';
import ReactLoader from '../../components/ReactLoader';
import { wait } from '@testing-library/user-event/dist/utils';
import Swal from 'sweetalert2';
const config = require('../../config.json')


export default function Task({ ipAddress, loginData }) {
    const [info, setInfo] = useState({});
    const [loading, setLoading] = useContext(LoadingContext)
    const [isset, setIsset] = useState(false);
    const [dr, setDr] = useState(false);
    const [lh, setLh] = useState(false);
    const handleInfo = useCallback(() => {
        setLoading(true)
        let data = JSON.stringify({
            "ip": ipAddress,
            "ulid": loginData.ulid
        });

        let axiosConfig = {
            method: 'post',
            maxBodyLength: Infinity,
            url: `${config.baseUrl}tasks`,
            headers: {
                'ip': ipAddress,
                'ulid': loginData.ulid,
                'auth': loginData.auth,
                'token': loginData.token,
                'Content-Type': 'application/json'
            },
            data: data
        };
        // console.log(axiosConfig)
        axios.request(axiosConfig)
            .then((response) => {
                console.log(response.data)
                setInfo(response.data)
                setLoading(false)
            })
            .catch((error) => {
                console.log(error);
            });
    }, [ipAddress, loginData.auth, loginData.token, loginData.ulid, setLoading])

    const handleTask = (uid, tid) => {
        if (isset) {
            Swal.fire({
                title: "AD Herbal",
                text: "Please Wait for Other Task completed. Or Refresh Page",
                icon: "warning"
            });
            return false;
        }
        else {
            setIsset(true)
            timeout(30000).then(() => {
                Swal.fire({
                    title: "AD Herbal",
                    text: "You Confirmed the Task",
                    icon: "question",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Yes",
                    cancelButtonText: "No"
                }).then((res) => {
                    setLoading(true)
                    if (res.isConfirmed) {
                        let data = JSON.stringify({
                            "ip": ipAddress,
                            "ulid": loginData.ulid,
                            "uid": uid,
                            "tid": tid
                        });
                        let axiosConfig = {
                            method: 'post',
                            maxBodyLength: Infinity,
                            url: `${config.baseUrl}taskdone`,
                            headers: {
                                'ip': ipAddress,
                                'ulid': loginData.ulid,
                                'auth': loginData.auth,
                                'token': loginData.token,
                                'Content-Type': 'application/json'
                            },
                            data: data
                        };
                        axios.request(axiosConfig)
                            .then((response) => {
                                console.log(response.data)
                                handleInfo()
                                setLoading(false)
                            })
                    }
                    else {
                        setLoading(false)
                    }
                })
            })
        }
    }


    async function timeout(delay) {
        return new Promise(res => setTimeout(res, delay));
    }
    useEffect(() => {
        handleInfo()
    }, [handleInfo])

    return (
        <>
            <div className="layout-container">
                <Menu />
                <div className="layout-page">
                    <Header />
                    {loading ? <><ReactLoader /></> :
                        <div className="content-wrapper mb-4">
                            <div className="container-xxl flex-grow-1 container-p-y pt-2">
                                <div>
                                    <div className='row'>
                                        <div className="col-md-12  mb-2">
                                            <div className="card">
                                                <div className="card-header align-items-center ">
                                                    <div className="card-title mb-0">
                                                        <h6 className="m-0 text-center text-black ">Tasks From AD Herbal</h6>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className="col-lg-4 col-md-6 col-sm-6 mb-2" key="n2">
                                            <div className="card">
                                                <div className="card-body dashinc">
                                                    <div className="d-flex justify-content-between">
                                                        <div className="card-info">
                                                            <p className="card-text m-0 text-black text-sm">Repurchase Wallet </p>
                                                            <div className="d-flex align-items-end mb-2">
                                                                <small className="text-black "><i className='bx bx-rupee bx-xs'></i>  {info?.rwallet}  </small>
                                                            </div>
                                                        </div>
                                                        <div className="card-icon">
                                                            <span className="badge bg-label-success rounded p-2">
                                                                <i className='bx bx-rupee bx-sm'></i>
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-md-12  mb-2">
                                            <div className="card h-100">
                                                <div
                                                    className="card-header align-items-center"
                                                    style={{ padding: "4% 5% 5% 5%" }}
                                                >
                                                    <div className="col-md-12">
                                                        <div className="row d-flex justify-content-between">
                                                            <div className="col-12 text-center">
                                                                <p className="card-text m-0 text-black  text-md">
                                                                    <b>Tasks</b>
                                                                </p>
                                                                <div className='row d-flex justify-content-between'>
                                                                    <div className='col-6 ' style={{ textAlignLast: "start" }}>
                                                                        <small className="text-sm">Pending : {info?.pending}</small>
                                                                    </div>
                                                                    <div className='col-6' style={{ textAlignLast: "end" }}>
                                                                        <small className="text-sm">Completed :  {info?.done}</small>
                                                                    </div>
                                                                </div>
                                                                <div className='row d-flex justify-content-between'>
                                                                    <div className='col-6 ' style={{ textAlignLast: "start" }}>
                                                                        <small className="text-sm">Paid Points: {info?.paid}</small>
                                                                    </div>
                                                                    <div className='col-6' style={{ textAlignLast: "end" }}>
                                                                        <small className="text-sm">Not Paid Points : {info?.pend}</small>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className='col-md-12 text-center mb-2'>
                                            <div className="btn-group justify-content-around" style={{ width: '100%' }}>
                                                <button type="button" className="btn btn-info text-sm" jf-ext-button-ct="left" onClick={() => { setDr(true); setLh(false); }}>Pending Task</button>
                                                <button type="button" className="btn btn-warning text-sm" jf-ext-button-ct="middle" onClick={() => { setDr(false); setLh(true); }}>Report</button>
                                                {/* <button type="button" className="btn btn-info text-sm" jf-ext-button-ct="middle" onClick={() => { setDr(false); setLh(false); setRh(true); }}>Right Team</button> */}
                                                {/* <button type="button" className="btn btn-warning text-sm" jf-ext-button-ct="right" onClick={() => { setWith(false); setReci(false); setSelf(false); setTran(true) }}>Send Other</button> */}
                                            </div>
                                        </div>
                                    </div>
                                    {(dr) &&
                                        <div className='row'>
                                            {
                                                info?.info?.map((list, index) => {

                                                    return (
                                                        <div className="col-md-4  mb-1" key={index + 1}>
                                                            <div className="card h-100">
                                                                <div className="card-header align-items-center" style={{ padding: "3% 5% 3% 5%" }}>
                                                                    <div className="col-md-12">
                                                                        <div className='row d-flex justify-content-between'>
                                                                            <div className='col-12 text-center'>
                                                                                <p className="text-black"> {list?.task_name}</p>
                                                                            </div>
                                                                        </div>
                                                                        <div className='row d-flex justify-content-between mb-2'>
                                                                            <div className='col-12 text-left'>
                                                                                <small className="text-sm">{list?.task_info}</small>
                                                                            </div>
                                                                        </div>
                                                                        <div className='row d-flex justify-content-between'>
                                                                            <div className='col-8 text-left'>
                                                                                <small className="text-sm">Points You erarn :  </small>
                                                                            </div>
                                                                            <div className='col-4' style={{ textAlignLast: "end" }}>
                                                                                <small className="text-sm">{list?.total_point}</small>
                                                                            </div>
                                                                        </div>
                                                                        <div className='row d-flex justify-content-between mb-2'>
                                                                            <div className='col-12 text-center'>
                                                                                <small className="text-sm text-danger">Task Will be Verified by Admin. So Please do it Corractly.</small>
                                                                            </div>
                                                                        </div>
                                                                        <div className='row d-flex justify-content-between mb-2'>
                                                                            <div className='text-center mt-0'>
                                                                                <a className='btn  btn-success rounded-pill btn-sm' href={list.task_link} target="_blank" onClick={() => handleTask(list.dgtid, list.id)} without="true" rel="noreferrer">View And Completed </a>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                    }
                                    {(lh) &&
                                        <div className='row'>
                                            {
                                                info?.report?.map((list, index) => {

                                                    return (
                                                        <div className="col-md-4  mb-1" key={index + 1}>
                                                            <div className="card h-100">
                                                                <div className="card-header align-items-center" style={{ padding: "3% 5% 3% 5%" }}>
                                                                    <div className="col-md-12">
                                                                        <div className='row d-flex justify-content-between'>
                                                                            <div className='col-12 text-center'>
                                                                                <p className="text-black"> {list?.task_name}</p>
                                                                            </div>
                                                                        </div>
                                                                        <div className='row d-flex justify-content-between mb-2'>
                                                                            <div className='col-12 text-left'>
                                                                                <small className="text-sm">{list?.task_info}</small>
                                                                            </div>
                                                                        </div>
                                                                        <div className='row d-flex justify-content-between'>
                                                                            <div className='col-8 text-left'>
                                                                                <small className="text-sm">Points You erarn :  </small>
                                                                            </div>
                                                                            <div className='col-4' style={{ textAlignLast: "end" }}>
                                                                                <small className="text-sm">{list?.total_point}</small>
                                                                            </div>
                                                                        </div>
                                                                        <div className='row d-flex justify-content-between'>
                                                                            <div className='col-8 text-left'>
                                                                                <small className="text-sm">COMPLETED : {list?.state}  </small>
                                                                            </div>
                                                                            <div className='col-4' style={{ textAlignLast: "end" }}>
                                                                                <small className="text-sm">{list?.cdt}</small>
                                                                            </div>
                                                                        </div>
                                                                        <div className='row d-flex justify-content-between'>
                                                                            <div className='col-8 text-left'>
                                                                                <small className="text-sm"> PAID: {list?.status}  </small>
                                                                            </div>
                                                                            <div className='col-4' style={{ textAlignLast: "end" }}>
                                                                                <small className="text-sm">{list?.pdt}</small>
                                                                            </div>
                                                                        </div>
                                                                        <div className='row d-flex justify-content-between mb-2'>
                                                                            <div className='text-center mt-0'>
                                                                                <a className='btn  btn-warning  rounded-pill btn-sm' href={list.task_link} target="_blank" without="true" rel="noreferrer">IF Not Completed by You. Please Do It Now. Or You Can't Get Points Paid </a>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                    }
                                </div>
                            </div>
                            <Footer />
                        </div>}
                </div>
            </div>

        </>
    );
}